import * as ngeohash from 'ngeohash';

const {
  encode,
  decode
} = ngeohash;
const encodeGeo = (loc, precision = 9) => {
  if (precision < 0 || precision > 9) {
    throw new Error('Precision must be between 0 and 9.');
  }

  const {
    lat,
    lng
  } = loc;
  return encode(lat, lng, precision);
};
const decodeGeo = hash => {
  const {
    latitude,
    longitude
  } = decode(hash);
  return {
    lat: latitude,
    lng: longitude
  };
};

export { decodeGeo, encodeGeo };
